import React from 'react';
import { Navigate } from 'react-router-dom';
import AdminDashboard from '../pages/admin/AdminDashboard';
import AdminLoginPage from '../pages/admin/AdminLoginPage';
import AdminClientsPage from '../pages/admin/AdminClientsPage';
import AdminClientDetailPage from '../pages/admin/AdminClientDetailPage';
import AdminServicesPage from '../pages/admin/AdminServicesPage';
import AdminServiceDetailPage from '../pages/admin/AdminServiceDetailPage';
import AdminPaymentsPage from '../pages/admin/AdminPaymentsPage';
import AdminAuditPage from '../pages/admin/AdminAuditPage';
import AdminProductsPage from '../pages/admin/AdminProductsPage';
import AdminPricingPage from '../pages/admin/AdminPricingPage';
import AdminNotificationsPage from '../pages/admin/AdminNotificationsPage';
import AdminSettingsPage from '../pages/admin/AdminSettingsPage';
import AdminLayout from '../components/admin/AdminLayout';
import AdminPrivateRoute from '../components/AdminPrivateRoute';
import AdminErrorBoundary from '../components/AdminErrorBoundary';

const adminRoute = (element: React.ReactElement) => (
  <AdminErrorBoundary>
    <AdminPrivateRoute>
      <AdminLayout>
        {element}
      </AdminLayout>
    </AdminPrivateRoute>
  </AdminErrorBoundary>
);

export interface RouteConfig {
  path: string;
  element: React.ReactElement;
  title?: string;
}

export const routes: RouteConfig[] = [
  {
    path: '/',
    element: <Navigate to="/admin" replace />,
    title: 'Home',
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
    title: 'Admin Login',
  },
  {
    path: '/admin',
    element: adminRoute(<AdminDashboard />),
    title: 'Admin Dashboard',
  },
  {
    path: '/admin/clients',
    element: adminRoute(<AdminClientsPage />),
    title: 'Admin Clients',
  },
  {
    path: '/admin/clients/:id',
    element: adminRoute(<AdminClientDetailPage />),
    title: 'Admin Client Detail',
  },
  {
    path: '/admin/services',
    element: adminRoute(<AdminServicesPage />),
    title: 'Admin Services',
  },
  {
    path: '/admin/services/:id',
    element: adminRoute(<AdminServiceDetailPage />),
    title: 'Admin Service Detail',
  },
  {
    path: '/admin/payments',
    element: adminRoute(<AdminPaymentsPage />),
    title: 'Admin Payments',
  },
  {
    path: '/admin/products',
    element: adminRoute(<AdminProductsPage />),
    title: 'Admin Products',
  },
  {
    path: '/admin/pricing',
    element: adminRoute(<AdminPricingPage />),
    title: 'Admin Pricing',
  },
  {
    path: '/admin/notifications',
    element: adminRoute(<AdminNotificationsPage />),
    title: 'Admin Notifications',
  },
  {
    path: '/admin/audit',
    element: adminRoute(<AdminAuditPage />),
    title: 'Admin Audit',
  },
  {
    path: '/admin/settings',
    element: adminRoute(<AdminSettingsPage />),
    title: 'Admin Settings',
  },
  {
    path: '*',
    element: <Navigate to="/admin" replace />,
    title: '404',
  },
];
